export default __webpack_public_path__ + "static/media/passport.76183d36.jpeg";